module.exports = __webpack_public_path__ + "static/media/fist-raised.c24fd920.svg";